// Central image registry — real The Nice Picnic brand photography.
// Replace files in /public/assets/brand/ to swap photography site-wide.
const B = "/assets/brand/";

export const BRAND = {
  logo: `${B}logo.jpg`,
  heroGroup: `${B}photo-01.jpg`,
  dj: `${B}photo-02.jpg`,
  toast: `${B}photo-03.jpg`,
  couple: `${B}photo-04.jpg`,
  terraceNice: `${B}photo-05.jpg`,
  spreadRoses: `${B}photo-06.jpg`,
  oliveWide: `${B}photo-07.jpg`,
  poufsDay: `${B}photo-08.jpg`,
  oliveTall: `${B}photo-09.jpg`,
  lanternsSunset: `${B}photo-10.jpg`,
  floating: `${B}photo-11.jpg`,
  duskGroup: `${B}photo-12.jpg`,
  juteSunset: `${B}photo-13.jpg`,
};

export const IMAGES = {
  hero: BRAND.heroGroup,
  bohoHero: BRAND.terraceNice,
  bohoDeco: BRAND.spreadRoses,
  bohoBeach: BRAND.duskGroup,
  floatingHero: BRAND.floating,
  floatingCove: BRAND.duskGroup,
  electronicHero: BRAND.dj,
  electronicParty: BRAND.lanternsSunset,
  foodBoard: BRAND.toast,
  foodWine: BRAND.oliveWide,
  sunsetDinner: BRAND.juteSunset,
  sunsetTable: BRAND.couple,
  aperitif: BRAND.spreadRoses,
  riviera: BRAND.oliveTall,
  villefranche: BRAND.poufsDay,
  marina: BRAND.duskGroup,
  beachClub: BRAND.poufsDay,
  sunsetGlasses: BRAND.couple,
  tropezSunset: BRAND.lanternsSunset,
};
